import {createContext, useContext} from 'react';

export interface SidePanelContextValue {
    openId: string | null;
    open: (id: string) => void;
    close: () => void;
    outlet: HTMLElement | null;
    setOutlet: (element: HTMLElement | null) => void;
}

export const SidePanelContext = createContext<SidePanelContextValue | null>(
    null
);

export function useSidePanelContext() {
    const context = useContext(SidePanelContext);
    if (!context) {
        throw new Error('SidePanelProvider is missing from the tree');
    }
    return context;
}

// Open, close or toggle one named panel. Opening a panel closes any other.
export function useSidePanel(id: string) {
    const {openId, open, close} = useSidePanelContext();
    const isOpen = openId === id;

    return {
        isOpen,
        open: () => open(id),
        close: () => {
            if (isOpen) {
                close();
            }
        },
        toggle: () => (isOpen ? close() : open(id))
    };
}
